/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiAnalytics,
  ApiAnalyticsFromJSON,
  ApiAnalyticsFromJSONTyped,
  ApiAnalyticsToJSON,
} from './ApiAnalytics';
import { ApiButton, ApiButtonFromJSON, ApiButtonFromJSONTyped, ApiButtonToJSON } from './ApiButton';
import { ApiCopy, ApiCopyFromJSON, ApiCopyFromJSONTyped, ApiCopyToJSON } from './ApiCopy';
import { ApiImages, ApiImagesFromJSON, ApiImagesFromJSONTyped, ApiImagesToJSON } from './ApiImages';
import {
  ApiInstrumentation,
  ApiInstrumentationFromJSON,
  ApiInstrumentationFromJSONTyped,
  ApiInstrumentationToJSON,
} from './ApiInstrumentation';
import { ApiLink, ApiLinkFromJSON, ApiLinkFromJSONTyped, ApiLinkToJSON } from './ApiLink';
import {
  ApiMediaPlayerConfig,
  ApiMediaPlayerConfigFromJSON,
  ApiMediaPlayerConfigFromJSONTyped,
  ApiMediaPlayerConfigToJSON,
} from './ApiMediaPlayerConfig';

/**
 *
 * @export
 * @interface ApiStandardContentBlockItem
 */
export interface ApiStandardContentBlockItem {
  /**
   *
   * @type {ApiAnalytics}
   * @memberof ApiStandardContentBlockItem
   */
  analytics: ApiAnalytics;
  /**
   *
   * @type {Array<ApiButton>}
   * @memberof ApiStandardContentBlockItem
   */
  ctas?: Array<ApiButton>;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  headerTag?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  horizontalAlignment?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  imageSize?: string;
  /**
   *
   * @type {ApiImages}
   * @memberof ApiStandardContentBlockItem
   */
  images?: ApiImages;
  /**
   *
   * @type {ApiInstrumentation}
   * @memberof ApiStandardContentBlockItem
   */
  instrumentation: ApiInstrumentation;
  /**
   *
   * @type {ApiCopy}
   * @memberof ApiStandardContentBlockItem
   */
  itemHeader?: ApiCopy;
  /**
   *
   * @type {ApiCopy}
   * @memberof ApiStandardContentBlockItem
   */
  itemSubHeader?: ApiCopy;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  itemType?: string;
  /**
   *
   * @type {ApiLink}
   * @memberof ApiStandardContentBlockItem
   */
  link?: ApiLink;
  /**
   *
   * @type {ApiMediaPlayerConfig}
   * @memberof ApiStandardContentBlockItem
   */
  mediaPlayerConfig?: ApiMediaPlayerConfig;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  padding?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardContentBlockItem
   */
  wistiaId?: string;
}

export function ApiStandardContentBlockItemFromJSON(json: any): ApiStandardContentBlockItem {
  return ApiStandardContentBlockItemFromJSONTyped(json, false);
}

export function ApiStandardContentBlockItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiStandardContentBlockItem {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    analytics: ApiAnalyticsFromJSON(json['analytics']),
    ctas: !exists(json, 'ctas') ? undefined : (json['ctas'] as Array<any>).map(ApiButtonFromJSON),
    headerTag: !exists(json, 'headerTag') ? undefined : json['headerTag'],
    horizontalAlignment: !exists(json, 'horizontalAlignment')
      ? undefined
      : json['horizontalAlignment'],
    id: json['id'],
    imageSize: !exists(json, 'imageSize') ? undefined : json['imageSize'],
    images: !exists(json, 'images') ? undefined : ApiImagesFromJSON(json['images']),
    instrumentation: ApiInstrumentationFromJSON(json['instrumentation']),
    itemHeader: !exists(json, 'itemHeader') ? undefined : ApiCopyFromJSON(json['itemHeader']),
    itemSubHeader: !exists(json, 'itemSubHeader')
      ? undefined
      : ApiCopyFromJSON(json['itemSubHeader']),
    itemType: !exists(json, 'itemType') ? undefined : json['itemType'],
    link: !exists(json, 'link') ? undefined : ApiLinkFromJSON(json['link']),
    mediaPlayerConfig: !exists(json, 'mediaPlayerConfig')
      ? undefined
      : ApiMediaPlayerConfigFromJSON(json['mediaPlayerConfig']),
    padding: !exists(json, 'padding') ? undefined : json['padding'],
    type: json['type'],
    wistiaId: !exists(json, 'wistiaId') ? undefined : json['wistiaId'],
  };
}

export function ApiStandardContentBlockItemToJSON(value?: ApiStandardContentBlockItem | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    analytics: ApiAnalyticsToJSON(value.analytics),
    ctas: value.ctas === undefined ? undefined : (value.ctas as Array<any>).map(ApiButtonToJSON),
    headerTag: value.headerTag,
    horizontalAlignment: value.horizontalAlignment,
    id: value.id,
    imageSize: value.imageSize,
    images: ApiImagesToJSON(value.images),
    instrumentation: ApiInstrumentationToJSON(value.instrumentation),
    itemHeader: ApiCopyToJSON(value.itemHeader),
    itemSubHeader: ApiCopyToJSON(value.itemSubHeader),
    itemType: value.itemType,
    link: ApiLinkToJSON(value.link),
    mediaPlayerConfig: ApiMediaPlayerConfigToJSON(value.mediaPlayerConfig),
    padding: value.padding,
    type: value.type,
    wistiaId: value.wistiaId,
  };
}
